import React from 'react';
import { Button } from 'react-bootstrap';

type Props = {
  canManage: boolean;
  currentImage?: string | null;
  onPickImage: () => void;
};

const CabDeckBrandEditor: React.FC<Props> = ({ canManage, currentImage, onPickImage }) => {
  return (
    <div className="mb-3">
      <h3 className="h6">Imagem do slide</h3>
      <p className="small text-muted mb-2">
        Slide full-bleed. Troque a imagem ou remova o slide na lista à esquerda.
      </p>
      {canManage ? (
        <Button size="sm" variant="outline-primary" onClick={onPickImage}>
          Trocar imagem…
        </Button>
      ) : null}
      <div className="small text-muted mt-2 text-break">Atual: {currentImage || '—'}</div>
    </div>
  );
};

export default CabDeckBrandEditor;
